import React from "react"
import styled from "styled-components"

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  grid-gap: 30px;
  max-width: 900px;
  margin: 0 auto;
  color: rgb(115, 117, 119);
  > :nth-child(2) {
    text-align: center;
    font-size: 1.3rem;
  }
  > :first-child,
  > :last-child {
    height: 1px;
    width: 100%;
    background-color: rgb(115, 117, 119);
  }
`

interface IProps {
  title: string
}

const TitleSeparator = (props: IProps) => (
  <Wrapper>
    <div />
    <h2>{props.title}</h2>
    <div />
  </Wrapper>
)

TitleSeparator.defaultProps = {}

export default TitleSeparator
